import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import { useToggle } from '../../hooks';
import Button, { ButtonColor, ButtonSize, ButtonVariant } from '../button/Button';
import { SymbolDirection } from '../symbol/Symbol';
import * as styles from './ExpandableContent.style';
import { ICON_CHEVRON } from '../../icons';
export const ExpandableContent = _ref => {
  let {
    openLabel,
    closeLabel,
    open,
    visibleFrom,
    children,
    ...rest
  } = _ref;
  const {
    opened,
    toggle
  } = useToggle(open);
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/React.createElement(_StyledDiv, {
    $open: opened,
    $visibleFrom: visibleFrom,
    $_css: styles.content
  }, children), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $visibleFrom: visibleFrom,
    $_css2: styles.toggle
  }, /*#__PURE__*/React.createElement(Button, {
    label: opened ? closeLabel : openLabel,
    variant: ButtonVariant.LIGHT,
    size: ButtonSize.SMALL,
    color: ButtonColor.NEUTRAL,
    icon: ICON_CHEVRON,
    iconDirection: opened ? SymbolDirection.TOP : SymbolDirection.BOTTOM,
    onClick: toggle,
    dataRef: "expandable-control",
    iconRight: true
  })));
};
ExpandableContent.defaultProps = {
  open: false,
  openLabel: 'Mostra',
  closeLabel: 'Nascondi'
};
export default ExpandableContent;
var _StyledDiv = _styled("div").withConfig({
  displayName: "ExpandableContent___StyledDiv",
  componentId: "sc-8jwdb6-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "ExpandableContent___StyledDiv2",
  componentId: "sc-8jwdb6-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=ExpandableContent.js.map